<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <input
      v-show="false"
      type="file"
      id="fileUploadSku"
      name="file"
      @change="handleSaveFile('sku')"
    />
    <input
      v-show="false"
      type="file"
      id="fileUploadProduct"
      name="file"
      @change="handleSaveFile('product')"
    />
    <el-form
      :model="form"
      ref="form"
      label-width="170px"
      :rules="rules"
      class="product-form"
    >
      <div class="t_plane self_el_item_form">
        <div class="pl_til">产品信息</div>
        <div class="pl_content">
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
            prop="shopId"
            label="选择店铺："
          >
            <el-select
              clearable
              filterable
              style="width: 100%"
              size="mini"
              v-model="form.shopId"
              @change="handleSelectShop"
              placeholder="请选择所属店铺"
            >
              <el-option
                v-if="item.authStatus == '02'"
                v-for="item in shopList"
                :key="item.value"
                :label="item.shopName"
                :value="item.shopId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :rules="[
              { required: true, message: '请输入内容', trigger: 'change' },
            ]"
            size="small"
            prop="category"
            label="类别："
          >
            <el-cascader
              :disabled="options.length == 0"
              v-model="form.category"
              style="width:100%;"
              placeholder="请输入类别"
              :options="options"
              :props="{ value: 'category_id', label: 'name' }"
              filterable
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="产品名称：" prop="productName">
            <el-input
              v-model="form.productName"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Parent SKU："
            style="margin-top: 20px"
            prop="parentSku"
          >
            <el-input
              v-model="form.parentSku"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="品牌：" prop="brand">
            <el-input
              v-model="form.brand"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>

          <el-form-item style="margin-bottom: 0" label="产品图片：">
            <span class="form-label" slot="label">
              <span style="color: red; margin: 0 5px 0 0">*</span>产品图片：
            </span>
            <div class="image-hint" style="position: relative">
              <div>
                点击图片拖动，即可调整图片顺序！ [图片最多选择9张，已经选择了{{
                  imageGroup.length
                }}张]
              </div>
            </div>
            <ul
              class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
            >
              <draggable
                :list="imageGroup"
                style="overflow: hidden; display: inline-block"
                filter=".forbid"
                @start="drag = true"
                @end="drag = false"
                :move="onMove"
              >
                <li
                  v-for="(record, index) in imageGroup"
                  :key="index"
                  class="sort-img-item"
                >
                  <img :src="record.lazadaPicUrl" />
                  <span class="first-pro-icon icon-corner-mark"></span>
                  <div class="wish-product-img-ope">
                    <a
                      @click.prevent="hanldeDeleteImage(imageGroup, index)"
                      class="set-delete"
                      >移除</a
                    >
                  </div>
                </li>
              </draggable>
              <li
                class="forbid"
                :class="{ 'add-image-button': true }"
                v-if="imageGroup.length < 9"
              >
                <p><i class="el-icon-plus"></i></p>
                <div class="variable-select-box">
                  <ul>
                    <li @click="handleUploadImageProduct">本地图片</li>
                  </ul>
                </div>
              </li>
            </ul>
          </el-form-item>
        </div>
      </div>
      <div class="t_plane self_el_item_form">
        <div class="pl_til">质保信息</div>
        <div class="pl_content">
          <el-form-item prop="warrantyType" label="质保类型：">
            <el-select
              clearable
              filterable
              style="width: 100%"
              size="mini"
              v-model="form.warrantyType"
              placeholder="请选择质保类型"
            >
              <el-option
                v-for="(value, index) in dictData['WARRANTY_TYPE']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item size="small" prop="warrantyTime" label="质保时间：">
            <el-select
              clearable
              filterable
              style="width: 100%"
              size="mini"
              v-model="form.warrantyTime"
              placeholder="请选择质保时间"
            >
              <el-option
                v-for="(value, index) in dictData['WARRANTY_TIME']"
                :key="index"
                :label="value.label"
                :value="value.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="质保政策：" prop="warrantyPolicy">
            <el-input
              v-model="form.warrantyPolicy"
              size="small"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <!--SKU信息-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">SKU信息</div>
        <div class="pl_content">
          <div class="color-list">
            <div
              style="display: inline-block; font-size: 14px; margin: 0 8px 0 0"
            >
              颜色：
            </div>
            <el-tag
              :key="tag"
              v-for="tag in colorTags"
              closable
              :disable-transitions="false"
              @close="handleColorClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-select
              filterable
              size="small"
              ref="saveTagColorInput"
              @change="handleColorInputConfirm"
              v-model="inputColorValue"
              v-if="inputColorVisible"
              style="margin: 0 0 0 8px"
            >
              <el-option
                v-for="(record, index) in dictData['color']"
                :value="record.value"
                :label="record.value"
                :key="index"
              ></el-option>
            </el-select>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showColorInput"
              >+ 新增颜色</el-button
            >
          </div>
          <div class="size-list">
            <div
              style="display: inline-block; font-size: 14px; margin: 0 8px 0 0"
            >
              尺寸：
            </div>
            <el-tag
              :key="tag"
              v-for="tag in sizeTags"
              closable
              :disable-transitions="false"
              @close="handleSizeClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputSizeVisible"
              v-model="inputSizeValue"
              ref="saveTagSizeInput"
              size="small"
              @keyup.enter.native="handleSizeInputConfirm"
              @blur="handleSizeInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showSizeInput"
              >+ 新增尺寸</el-button
            >
          </div>
          <div class="sku-list">
            <el-table
              id="outTable"
              ref="table"
              :data="skuList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="name" label="变种信息" align="center">
                <template slot-scope="scope">
                  <div v-html="scope.row.properVal"></div>
                </template>
              </el-table-column>
              <el-table-column label="SKU" align="center">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="scope.row.sellerSku"
                    maxlength="100"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="价格(₱)"
                align="left"
                prop="price"
                width="150"
                header-align="center"
              >
                <template slot="header">
                  价格<br />(<span
                    @click="handleShowCellDialog('price', '价格')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div class="text-ellipsis" style="margin: 0 0 4px 0;">
                    <el-input size="small" v-model="scope.row.price"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                label="库存"
                prop="quantity"
                width="150"
              >
                <template slot="header">
                  库存<br />(<span
                    @click="handleShowCellDialog('quantity', '库存')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div class="text-ellipsis" style="margin: 0 0 4px 0;">
                    <el-input
                      size="small"
                      v-model="scope.row.quantity"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="重量(kg)"
                header-align="center"
                align="left"
                prop="packageWeight"
                width="95"
              >
                <template slot="header">
                  重量<br />(<span
                    @click="handleShowCellDialog('packageWeight', '重量')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div class="text-ellipsis" style="margin: 0 0 4px 0;">
                    <el-input
                      style="width:72px;"
                      size="small"
                      v-model="scope.row.packageWeight"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="包装尺寸(cm)"
                header-align="center"
                align="left"
                prop="packageLength"
                width="179px"
              >
                <template slot="header">
                  包装尺寸<br />(<span
                    @click="handleShowCellDialog('packageLength', '包装尺寸')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div
                    class="text-ellipsis"
                    style="width:280px;margin: 0 0 4px 0;"
                  >
                    <el-input
                      placeholder="长"
                      style="width:50px;margin-right:4px;"
                      size="small"
                      v-model="scope.row.packageLength"
                    ></el-input>
                    <el-input
                      placeholder="宽"
                      style="width:50px;margin-right:4px;"
                      size="small"
                      v-model="scope.row.packageWidth"
                    ></el-input>
                    <el-input
                      placeholder="高"
                      style="width:50px"
                      size="small"
                      v-model="scope.row.packageHeight"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="促销价(₱)"
                header-align="center"
                align="left"
                prop="specialPrice"
                width="150"
              >
                <template slot="header">
                  促销价<br />(<span
                    @click="handleShowCellDialog('specialPrice', '促销价')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div class="text-ellipsis" style="margin: 0 0 4px 0;">
                    <el-input
                      size="small"
                      v-model="scope.row.specialPrice"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="促销时间"
                header-align="center"
                align="left"
                prop="specialTime"
                width="300px"
              >
                <template slot="header">
                  促销时间<br />(<span
                    @click="handleShowCellDialog('specialTime', '促销时间')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <div class="text-ellipsis">
                    <el-date-picker
                      @blur="handleUpdateSpecialTime"
                      size="small"
                      v-model="scope.row.specialTime"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!--变种图片-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">图片信息</div>
        <div class="pl_content">
          <div v-for="(value, key) in picList" :key="key" class="color-content">
            <div class="pl-title">变种信息：{{ key }}</div>
            <ul
              class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
            >
              <draggable
                :list="value"
                style="overflow: hidden"
                filter=".forbid"
                @start="drag = true"
                @end="drag = false"
                :move="onMove"
              >
                <li
                  v-for="(record, index) in value"
                  :key="index"
                  class="sort-img-item"
                  :class="index === 0 ? 'forbid' : ''"
                >
                  <img
                    :src="
                      record.picUrl ? record.picUrl : record.lazadaSkuPicUrl
                    "
                  />
                  <span class="first-pro-icon icon-corner-mark"></span>
                  <div class="wish-product-img-ope">
                    <div style="width: 100%; overflow: hidden">
                      <a
                        @click.prevent="hanldeDeleteImage(value, index)"
                        class="set-main"
                        style="margin: 0 8px 0 0"
                        >移除</a
                      >
                    </div>
                  </div>
                </li>
                <li
                  @click="handleUploadImageSku(key)"
                  v-if="value && value.length < 9"
                  class="sort-img-item add-image-button forbid"
                >
                  <p><i class="el-icon-plus"></i></p>
                </li>
              </draggable>
            </ul>
          </div>
        </div>
      </div>

      <!--描述信息-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">描述信息</div>
        <div class="pl_content">
          <el-form-item class="wd100" label="长描述：">
            <CKEditor4
              ref="ckEditor1"
              v-model="form.longDesc"
              :config="editorConfig"
              @getCkEditorInstance="getEditor1"
              @input="handleChangeEditor"
              @open="openUploadDialog1"
            ></CKEditor4>
          </el-form-item>
          <el-form-item class="wd100" label="短描述：">
            <CKEditor4
              ref="ckEditor2"
              v-model="form.shortDesc"
              :config="editorConfig"
              @getCkEditorInstance="getEditor2"
              @input="handleChangeEditor"
              @open="openUploadDialog2"
            ></CKEditor4>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <el-dialog
      :close-on-click-modal="false"
      :title="`修改${cellTitle}`"
      :visible.sync="showCellDialog"
      width="580px"
      @close="handleCloseCellDialog"
    >
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span style="display: inline-block;float:left;margin: 4px 0 0 0;"
          >{{ cellTitle }}：</span
        >
        <span
          v-if="cellType == 'packageLength'"
          class="text-ellipsis"
          style="width:280px;display: inline-block;float:left;"
        >
          <el-input
            placeholder="长"
            style="width:50px;margin-right:4px;"
            size="small"
            v-model="cellForm.packageLength"
          ></el-input>
          <el-input
            placeholder="宽"
            style="width:50px;margin-right:4px;"
            size="small"
            v-model="cellForm.packageWidth"
          ></el-input>
          <el-input
            placeholder="高"
            style="width:50px"
            size="small"
            v-model="cellForm.packageHeight"
          ></el-input>
        </span>
        <div
          v-else-if="cellType == 'specialTime'"
          class="text-ellipsis"
          style="display: inline-block;float:left;"
        >
          <el-date-picker
            size="small"
            v-model="cellValue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <el-input
          v-else
          v-model.trim="cellValue"
          :title="`请输入${cellTitle}`"
          size="mini"
          style="width: 450px;float:left;"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCellDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="handleUpdateCell" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :title="`修改${this.priceType === 'weight' ? '重量' : '价格'}`"
      :visible.sync="showPriceDialog"
      width="560px"
      @close="handleClosePriceDialog"
    >
      <el-row style="margin-top: 15px; margin-left: 15px">
        {{ this.priceType === "weight" ? "重量" : "价格" }}：
        <el-input
          v-model.trim="priceModify"
          onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
          :title="`请输入${this.priceType === 'weight' ? '重量' : '价格'}`"
          size="mini"
          style="width: 450px"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePriceDialog" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleUpdatePrice" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <LocalUpload :ckData="localUploadData1"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData1"></OnlineUpload>
    <LocalUpload :ckData="localUploadData2"></LocalUpload>
    <OnlineUpload :ckData="onlineUploadData2"></OnlineUpload>
    <div class="sidebar__style">
      <div @click="handleSubmitForm('01')" class="button__style goTop__style">
        保存<br />草稿
      </div>
      <div @click="handleSubmitForm('02')" class="button__style submit__style">
        立即<br />发布
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import ElRow from "element-ui/packages/row/src/row";
import CKEditor4 from '@/components/common/CKEditor'
import TreeSelect from '@/components/common/treeSelect';
import { getProductTypeTree } from "@/api/product/type";
import { addProduct, getProductDetail , getEditInfo } from "@/api/customProduct/product";
import draggable from "vuedraggable"
import LocalUpload from "@/components/common/ckEditorUploadPage/localUpload"
import OnlineUpload from "@/components/common/ckEditorUploadPage/onlineUpload"
import { listUser, editUser } from "@/api/business/merchantManage"
import {mapGetters} from 'vuex'
import { getOSSToken } from "@/api/setting";
import { getDesign } from "@/api/customProduct/design"
import { getShopList, syncLazada, getLazadaCategory } from "@/api/shop/shop"
import { addLazada , getProductList } from "@/api/order/lazada"


export default {
    name: "createLazada",
    components:{
        ElRow,
        Breadcrumb,
        CKEditor4,
        TreeSelect,
        draggable,
        LocalUpload,
        OnlineUpload
    },
    computed: {
      ...mapGetters(["dictData", "dictMap"]),
    },
    data(){
      return{
        priceModify: '',
        form:{
          "pId": "",
          "productName": "",
          "parentSku": "",
          "shopId": "",
          "brand": "",
          "longDesc": "",
          "shortDesc": "",
          "status": "01",
          "category": "",
          "categoryAdd": "",
           "warrantyType": "",
          "warrantyTime": "",
          "warrantyPolicy": "",
          skuList: [],
        },
        productTypeList: [],
        treeSelectProps: {
          value:'typeId',             // ID字段名
          label: 'typeName',         // 显示名称
          children: 'childrenTree'    // 子级字段名
        },
        cellForm: {
        packageWidth: "",
        packageHeight: "",
        packageLength: "",
        specialTime: [],
      },
      cellValue: '',
      cellTitle: '',
      showCellDialog: false,
        colorTags: [],
        inputColorVisible: false,
        inputColorValue: '',
        sizeTags: [],
        options: [],
        inputSizeVisible: false,
        inputSizeValue: '',
        skuList: [],
        picList: {},
         shopList: [],
        embroideryList: [{
          lowNum : '',
          highNum: '',
          discount: ''
        }],
        currentColor: '',
        aliyunOssToken: {},
        rules: {
            shopId: [
                {required: true, message: '请输入店铺', trigger: 'change'},
            ],
            category: [
                {required: true, message: '请输入产品分类', trigger: 'blur'},
            ],
            productName: [
                {required: true, message: '请输入产品名称', trigger: 'blur'},
            ],
            brand: [
                {required: true, message: '请选择品牌', trigger: 'blur'},
            ],
        },
        imageGroup: [],
        labelAttrList: [],
        merchantList: [],
        showPriceDialog: false,
        //描述文本框
        editor1:null,
        editor2:null,
        editorConfig: {
        allowedContent: true, //设置为true，以防止CKEditor 4删除不允许的元素
        extraPlugins: ["uploadImg"],
        height: "300px",
        toolbar: [
          ["Maximize"],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          [
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Subscript",
            "Superscript",
          ],
          ["HorizontalRule", "RemoveFormat"],
          ["Undo", "Redo"],
          "/",
          ["Styles", "Format", "Font", "FontSize"],
          ["Table"],
          ["uploadImg"],
        ],

        language: "zh-cn",
        wordcount: {
          showCharCount: true,
        },
        },
       localUploadData1: {
          visible: false,
          editor: null,
        },
        onlineUploadData1: {
          visible: false,
          editor: null,
        },
        localUploadData2: {
          visible: false,
          editor: null,
        },
        onlineUploadData2: {
          visible: false,
          editor: null,
        },
        priceType: '',
        domain: '',
        dialogForm: {
          content: ''
        }
      }
    },
    async created() {
      this.getMerchantList()
      this.getOssToken()
    },
   async mounted(){
      await this.getShopList()
      let pId = this.$route.query.pId
      if(pId){
        let result = await getProductList({ pIds: pId , status: 'active' })
        this.picList = {}
        if(result.rows.length> 0){
           this.$nextTick(async ()=>{
           this.form = result.rows[0]
          this.imageGroup = this.form.picList
          this.skuList = this.form.skuList
          let colorTags = []
          let sizeTags = []
          try {
             for(let record of this.skuList){
            if(!colorTags.includes(record.color)){
              colorTags.push(record.color)
            }
            if(!sizeTags.includes(record.size)){
              sizeTags.push(record.size)
            }
            record.properVal = record.color + ':' + record.size
            if(!record.specialFromTime || !record.specialToTime){
              record.specialTime = []
            }else {
              record.specialTime = [record.specialFromTime, record.specialToTime]
            }

            let picList = []
            for(let data of  record.picList){
              picList.push({picUrl: data.lazadaSkuPicUrl})
            }

            if(!this.picList[record.color]){
              this.picList[record.color] = picList
            }
          }
          } catch (error) {
            console.log(error)
          }
          this.colorTags = colorTags
          this.sizeTags = sizeTags
          await this.handleSelectShop(this.form.shopId)
          let categoryAdd = this.form.categoryAdd.split(',')
          let category = []
          for(let record of categoryAdd){
            category.push(Number(record))
          }
          this.form.category = category
          this.$refs['ckEditor1'].setData(this.form.longDesc)
          this.$refs['ckEditor2'].setData(this.form.shortDesc)
          
          }
          )}

      }
    },
    methods:{
      onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
      },
       getShopList() {
      getShopList({ platNo: "03" }).then((res) => {
        this.shopList = res.rows.filter((record)=>{
          return !record.isExpire
        })
      })
    },
     async handleSelectShop(shopId) {
      let result = await getLazadaCategory(shopId)
      this.options = result.data
    },
      handleUpdatePrice(){
        for(let record of this.skuList){
          if(this.priceType === 'costPrice'){
            record.costPrice = this.priceModify
          }else if(this.priceType === 'sellPrice'){
            record.sellPrice = this.priceModify
          } else if(this.priceType === 'lowPrice'){
            record.lowPrice = this.priceModify
          } else if(this.priceType === 'weight'){
            record.weight = this.priceModify
          } else if(this.priceType === 'discountPrice'){
            for(let item of record.priceList){
              item.price = this.priceModify
            }
          }
        }
        this.showPriceDialog = false
      },
      handleClosePriceDialog(){
        this.showPriceDialog = false
      },
      handleShowPriceDialog(priceType){
        this.priceModify = ''
        this.showPriceDialog = true
        this.priceType = priceType
      },
      handleAddRow(){
        this.embroideryList.push({
          lowNum : '',
          highNum: '',
          discount: ''
        })
      },
      handleDeleteRow(index){
        this.embroideryList.splice(index)
      },
      async handleSubmitForm(dzStatus){
          this.$refs['form'].validate(async (valid) => {
          if (valid) {
              let form = JSON.parse(JSON.stringify(this.form))
              let picList = JSON.parse(JSON.stringify(this.picList))
              form.skuList = JSON.parse(JSON.stringify(this.skuList))
              form.categoryAdd = form.category.join(',')
              form.category = form.category[form.category.length - 1]
              form.longDesc = this.editor1.getData()
              form.shortDesc = this.editor2.getData()
              form.status = dzStatus
              form.picList = this.imageGroup
              if(form.skuList && form.skuList.length == 0){
                this.msgError('请填写SKU信息')
                return
              }

              for(let record of form.skuList){
                if(picList[record.color]){
                  record.picList = picList[record.color]
                  for(let image of picList[record.color]){
                    if(image.picUrl){
                      image.lazadaSkuPicUrl = image.picUrl
                    }
                  }
                }
                if(record.specialTime && record.specialTime.length > 0){
                  record.specialFromTime = record.specialTime[0] + ' 00:00:00'
                  record.specialToTime = record.specialTime[1]+ ' 00:00:00'
                }
                record.status = 'active'
                delete record["specialTime"]
              }

              try {
                await addLazada(form)
                this.msgSuccess("保存成功");
                if(dzStatus == '01'){
                  this.$router.push({ path: "/carry/lazada/draftProduct", query: {
                    pageSize: this.$route.query.pageSize, pageNum: this.$route.query.pageNum
                  } })
                } else{
                  this.$router.push({ path: "/carry/lazada/onlineProduct", query: {
                    pageSize: this.$route.query.pageSize, pageNum: this.$route.query.pageNum
                  } })
                }

              } catch (error) {
              }
                } else {
                  this.msgError("请填写必填项");
                  return false;
                }
        });


      },
      async getProductTypeTree() {
        let result = await getProductTypeTree();
        this.productTypeList = result.data;
      },
      getTreeNodeId(value){
        this.form.typeId = value
      },
      handleAddPrice(row){
        row.push({
          lowNum:'',
          highNum: '',
          price: ''
        })
      },
      handleDeletePrice(row,index){
        row.splice(index, 1)
      },
      handleColorClose(tag) {
        this.colorTags.splice(this.colorTags.indexOf(tag), 1);
        delete this.picList[tag]
        this.renderSkuList();
      },
      showColorInput() {
        this.inputColorVisible = true;
        this.$nextTick(_ => {
          // this.$refs.saveTagColorInput.$refs.input.focus();
        });
      },
        handleCloseCellDialog() {
      this.showCellDialog = false
    },
    handleUpdateCell() {
      for (let record of this.skuList) {
        if (
          this.cellType == "quantity" ||
          this.cellType == "price" ||
          this.cellType == "specialPrice" ||
          this.cellType == "packageWeight" ||
          this.cellType == "specialTime"
        ) {
            record[this.cellType] = this.cellValue
        } else if (this.cellType == "packageLength") {
            record["packageLength"] = this.cellForm.packageLength
            record["packageWidth"] = this.cellForm.packageWidth
            record["packageHeight"] = this.cellForm.packageHeight
        } else {
          record[this.cellType] = this.cellValue
        }
      }
      if (this.cellType == "specialTime") {
        this.skuList = this._.clone(this.skuList)
      }
      this.showCellDialog = false
    },
       handleShowCellDialog(cellType, cellTitle) {
      this.cellValue = ""
      this.cellForm = {
        packageWidth: "",
        packageHeight: "",
        packageLength: "",
        specialTime: [],
      }
      this.showCellDialog = true
      this.cellType = cellType
      this.cellTitle = cellTitle
    },
      handleColorInputConfirm() {
        let inputValue = this.inputColorValue;
        if(inputValue.trim() === ''){
          this.inputColorVisible = false;
          this.inputColorValue = '';
          return
        }
        if(this.colorTags.indexOf(inputValue) > -1){
          this.msgWarning('颜色名称已存在，请重新填写')
          return
        }
        if (inputValue) {
          this.colorTags.push(inputValue.trim());
        }
        this.inputColorVisible = false;
        this.inputColorValue = '';
        this.picList[inputValue] = []
        this.renderSkuList();

      },
      handleSizeClose(tag) {
        this.sizeTags.splice(this.sizeTags.indexOf(tag), 1);
        //只删除对应的SIZE
        for(let i = 0;i< this.sizeData.length;i++){
          if(this.sizeData[i].size === tag){
            this.packageData.splice(i,1)
            this.sizeData.splice(i,1)
            break
          }
        }
        this.renderSkuList();
      },
      showSizeInput() {
        this.inputSizeVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagSizeInput.$refs.input.focus();
        });
      },
      handleSizeInputConfirm() {
        let inputValue = this.inputSizeValue;
        if(inputValue.trim() === ''){
          this.inputSizeVisible = false;
          this.inputSizeValue = '';
          return
        }
         if(this.sizeTags.indexOf(inputValue) > -1){
          this.msgWarning('标签名称已存在，请重新填写')
          return
        }
        if (inputValue) {
          this.sizeTags.push(inputValue.trim());
        }
        this.inputSizeVisible = false;
        this.inputSizeValue = '';

        this.renderSkuList();
      },
      renderSkuList(){
        let skuList = this._.clone(this.skuList)
        this.skuList = []
        if(this.sizeTags.length === 0 || this.colorTags.length === 0){
          return
        }

        for(let color of this.colorTags){
          for(let size of this.sizeTags){
            let find = false
            for(let record of skuList){
              if(record.properVal ==  `${color}:${size}`){
                find = true
                this.skuList.push(record)
                break
              }
            }
            if(!find){
              this.skuList.push({
                sellerSku: '',
                color: color,
                size: size,
                quantity: '',
                price: '',
                properVal: `${color}:${size}`,
                specialPrice: '',
                packageWidth: '',
                packageHeight: '',
                packageLength: '',
                packageWeight: '',
                specialToTime: '',
                specialFromTime: '',
              })
            }
          }
        }
      },
      getEditor1(value){
        this.editor1 = this.localUploadData1.editor = this.onlineUploadData1.editor = value
      },
      getEditor2(value){
        this.editor2 = this.localUploadData2.editor = this.onlineUploadData2.editor = value
      },
      handleChangeEditor(value){
        // this.dialogForm.conten = value
      },
      openUploadDialog1(val) {
        if (val == "local") {
          this.localUploadData1.visible = true
        } else if (val == "online") {
          this.onlineUploadData1.visible = true
        }
      },
       openUploadDialog2(val) {
        if (val == "local") {
          this.localUploadData2.visible = true
        } else if (val == "online") {
          this.onlineUploadData2.visible = true
        }
      },
      handleSetMainImage1(list ,index){
        list.map(item=>{
          if(item.isMain == '1'){

          item.isMain = '0'
          }
        })
        list[index].isMain = '1'
        let record = list[index]
        //插入到第一个元素
        list.splice(index , 1)
        list.unshift(record)
      },
      handleSetMainImage2(list ,index){
        list.map(item=>{
          if(item.isMain == '2'){
            item.isMain = '0'
          }
        })
        list[index].isMain = '2'
        let record = list[index]
        //插入到第一个元素
        list.splice(index , 1)
        list.unshift(record)
      },
      handleSetSizeImage(list ,index){
        list[index].isMain = '3'
      },
      handleUnSetSizeImage(list ,index){
        list[index].isMain = '0'
      },
      hanldeDeleteImage(list, index){
        list.splice(index , 1)
      },
      handleUploadImageSku(color){
        this.currentColor = color;
        document.querySelector('#fileUploadSku').click()
      },
        handleUploadImageProduct(){
        document.querySelector('#fileUploadProduct').click()
      },
      getOssToken() {
        var _self = this
        getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getMerchantList() {
        var _self = this
        listUser({userType: '01'})
        .then(function (res) {
          if (res.code == 200) {
            _self.merchantList = res.rows
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      handleUpdateSpecialTime() {
        this.skuList = this._.clone(this.skuList)
      } ,
      handleSaveFile(fileType) {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = fileType == 'sku' ? $("#fileUploadSku").val() : $("#fileUploadProduct").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", fileType == 'sku' ? $("#fileUploadSku")[0].files[0] : $("#fileUploadProduct")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码
        this.domain = _self.aliyunOssToken.host + "/"

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            if(fileType == 'sku'){
              _self.picList[_self.currentColor].push({
                picUrl: fileUrl,
                isMain: _self.picList[_self.currentColor].length === 0 ? true : false
              })
              let array =JSON.parse(JSON.stringify(_self.picList))
              _self.picList = array
              $("#fileUploadSku").val(null)

            } else{
               _self.imageGroup.push({
                  lazadaPicUrl: fileUrl,
                })
              $("#fileUploadProduct").val(null)
            }

          },
          error: function (data) {
             $("#fileUpload").val(null)
            $("#fileUploadProduct").val(null)
          },
        })
    },
    }
}
</script>

<style lang="scss" scoped>
.headerBorder {
  border: 1px solid darkgrey;
}
.container {
  margin-top: 15px;
}
.main {
  border: 1px solid darkgrey;
  border-top: none;
  width: 100%;
}
.el-header {
  height: 40px;
}
.inputSize {
  width: 300px;
}
.image {
  width: 88px;
  display: block;
  height: 100px;
}
.product-form {
  background: #ffffff;
  padding: 16px;
  ::v-deep .el-form-item__content {
    width: 600px;
  }

  ::v-deep .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .wd100 {
    ::v-deep .el-form-item__content {
      width: calc(100% - 100px);
    }
  }
}
.pl_til {
  background-color: #ffffff;
  border-bottom: none;
  border-left: 4px solid #409eff;
  padding: 0 0 0 15px;
  font-size: 15px;
  color: #333333;
  font-weight: inherit;
}
.t_plane {
  border: none;
  border-radius: 0px;
}
.color-list {
  margin: 0 0 16px 0;
}
.price-set {
  font-size: 16px;
}
.sku-list {
  margin: 8px 0 0 0;
}
.pl-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.extra-image-ul > li,
.extra-image-ul > li {
  background: #eeeeee;
}
.sort-img-item {
  position: relative;
  width: 100px;
  height: 100px;
  display: inline-block;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
  }
}

.extra-image-ul > li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.add-image-button {
  background: #ebeef5;
}
.add-image-button > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
  font-size: 20px;
}
.item-badge {
  position: absolute;
  color: rgb(255, 165, 79);
  font-weight: bold;
  font-size: 14px;
  top: 5px;
  left: 6px;
  // -ms-transform: rotate(-35deg);
  // -webkit-transform: rotate(-35deg);
  // transform: rotate(-35deg);
  -webkit-transition: 0 0.1s ease-in;
  -moz-transition: 0 0.1s ease-in;
  -o-transition: 0 0.1s ease-in;
  transition: transform 0.1s ease-in;
  z-index: 100;
}
li .wish-product-img-ope,
li .wish-product-img-ope,
li .wish-product-img-ope {
  width: calc(100% - 8px);
  padding: 1px 4px;
  background: #3ba5ea;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  line-height: 20px;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
  a {
    color: #ffffff;
  }
  .set-main {
    float: left;
    cursor: pointer;
  }
  .set-delete {
    float: right;
    cursor: pointer;
  }
}
.price-set {
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 16px;
  }
}
.image-hint {
  color: #606266;
}
li.sort-img-item {
  background: #eeeeee;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
  }
}

.extra-image-ul > div > li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.extra-image-ul > li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.extra-image-ul > div > li > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
}
li.add-image-button > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
}
.w70 {
  width: 70% !important;
}
.add-image-button {
  font-size: 24px;
  vertical-align: 15px;
  position: relative;
}
.add-image-button:hover .variable-select-box {
  display: block;
}
.variable-select-box {
  position: absolute;
  top: 0;
  left: 100px;
  z-index: 999999;
  background: #fff;
  border: 1px solid rgb(225, 227, 229);
  border-radius: 4px;
  font-size: 12px;
  display: none;
}

.variable-select-box li {
  height: 28px;
  line-height: 28px;
  padding: 0 15px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
}
.variable-select-box > ul > li:hover {
  background: #428bca;
  color: #fff;
}
.variable-select-box > ul > li:hover .variable-pick-ul {
  display: block;
}

.variable-pick-ul {
  position: absolute;
  top: -1px;
  left: 76px;
  background: #fff;
  border: 1px solid rgb(225, 227, 229);
  border-radius: 4px;
  z-index: 10;
  display: none;
}
.variable-pick-ul li:hover {
  background: #428bca;
  color: #fff;
}
.variable-pick-ul li {
  color: #000;
  white-space: nowrap;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #409eff;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #409eff;
  color: #fff;
  background-color: #409eff;
}
</style>
